// components

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import { Checkbox } from '@progress/kendo-react-inputs';
import { Dialog, DialogActionsBar, Window, WindowActionsBar } from '@progress/kendo-react-dialogs';

// css
import styles from './userInfo_mobile.module.css';
import "./userInfo_mobile.css";

// services
import { authGuest, setDelToken, setToken, getUser, isUser, isProtector } from "../../../service/authService";
import { getUserInfo, getUserList } from './../../../service/mobile/userInfoService';
import { getAlarmNo, setUpdateAlert } from '../../../service/log/alertLogService';

function UserInfoMobile({conn, setUpdateLoginStatus, loginStatus, setState}) {

  const userInfo = getUser();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    userId: userInfo.userTypeCode !== 2006 ? userInfo.userId : userInfo.userId.split("_")[0],
  });
  const [dataSource, setDataSource] = useState();
  const [dataItem, setDataItem] = useState({
    // 대상자 정보
    userTerm: null, // 이름
    meainStatCode: null, // 이벤트 코드
    meainStatTerm: null, // 이벤트 명
    dataStatSctCodeNo: null, // 상태 코드
    dataStatTerm: null, // 상태 명
    latestDataStatTime: null, // 지속시간
    movement: null, // 움직임
    velocityTotal: null, // 속도 총합
    temperature: null, //  온도
    humidity: null, // 습도
    co2: null, // co2
    light: null, // 조도
    cid: null, // CID 
    bizType: null, // 사업타입
    userId: null, // 대상자 아이디
    // 대상자 상세정보
    birthday: null, // 생년월일
    userGender: null, // 성별
    dongTerm: null, // 주소
    address: null, // 상세주소
    userPhone: null, // 연락처
    protectorPhone: null, // 보호자 연락처
    sickType: null, // 보유지병
    note: null, // 특이사항
    imei: null,
    fileIdUserPhoto: null,
    fileIdPlacePhoto1: null,
    fileIdPlacePhoto2: null,
    // 대상자 이벤트 상태 확인
    callYn: "N",
    visitYn: "N",
    alarmNo: null,
    processingContent: null,
    absenceYn: null,
    dangerYn: null,
  })

  // DIALOG 관리
  const [changeEventDialogVisible, setChangeEventDialogVisible] = useState(false);
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);

  const closeChangeEventDialog = () => {
    setChangeEventDialogVisible(false);
  }

  const closeCompleteDialog = () => {
    setChangeEventDialogVisible(false);
    setCompleteDialogVisible(false);
  }

  // 정상전환 조치내용
  const changeEventContent = (e) => {
    setDataItem(dataItem => {
      const item = { ...dataItem };
      item.processingContent = e.target.value;
      return item;
    })
  }

  // 정상전환 저장
  const saveChangeEventDialog = () => {
    const data = {
      alarmNo: dataItem.alarmNo,
      elderId: dataItem.userId,
      callYn: dataItem.callYn,
      visitYn: dataItem.visitYn,
      processingContent: dataItem.processingContent,
      checkId: userInfo.userId,
      checkTerm: userInfo.checkTerm,
      checkDtm: new Date(),
    };
    setUpdateAlert(conn, data)
    .then(() => {
      dataItem.meainStatCode = "20001";
      dataItem.meainStatTerm = "정상";
      setCompleteDialogVisible(true);
    })
    .catch(error => {
      console.log("setUpdateAlert Error", error);
    });
  }

  // 대상자 이벤트 색상
  const eventBackground = () => {
    if(dataItem.meainStatCode === "20001") {
      return "#1f6310"
    } else if(dataItem.meainStatCode === "20002") {
      return "#dfc42d"
    } else if(dataItem.meainStatCode === "20003") {
      return "#91918e"
    } else if(dataItem.meainStatCode === "20004") {
      return "#d42c2c"
    } else {
      return "#91918e"
    }
  }

  // 대상자 상태 표시
  const userStateImg = () => {
    if(dataItem.dataStatSctCodeNo === 10001) {
      return <img src="/images/mobile/con_01_b.png"></img>
    } else if(dataItem.dataStatSctCodeNo === 10002) {
      return <img src="/images/mobile/con_05_b.png"></img>
    } else if(dataItem.dataStatSctCodeNo === 10003) {
      return <img src="/images/mobile/con_06_b.png"></img>
    } else if(dataItem.dataStatSctCodeNo === 10004) {
      return <img src="/images/mobile/con_06_b.png"></img>
    } else if(dataItem.dataStatSctCodeNo === 10005) {
      return <img src="/images/mobile/con_02_b.png"></img>
    } else if(dataItem.dataStatSctCodeNo === 10006) {
      return <img src="/images/mobile/con_03_b.png"></img>
    } else {
      return <img src="/images/mobile/con_04_b.png"></img>
    }
  }

  // 대상자 이벤트 표시
  const userEventImg = () => {
    if(dataItem.meainStatCode === "20001") {
      return <img src="/images/mobile/normal2.png"></img>
    } else if(dataItem.meainStatCode === "20002") {
      return <img src="/images/mobile/warn2.png"></img>
    } else if(dataItem.meainStatCode === "20003") {
      return <img src="/images/mobile/off2.png"></img>
    } else if(dataItem.meainStatCode === "20004") {
      return <img src="/images/mobile/danger2.png"></img>
    } else {
      return <img src="/images/mobile/off2.png"></img>
    }
  }

  // 통화확인 여부 체크
  const callCheckEvent = (e) => {
    if(e.value === true) {
      setDataItem(dataItem => {
        const item = { ...dataItem };
        item.callYn = "Y";
        return item;
      })
    } else {
      setDataItem(dataItem => {
        const item = { ...dataItem };
        item.callYn = "N";
        return item;
      })
    }
  }

  // 방문확인 여부 체크
  const visitCheckEvent = (e) => {
    if(e.value === true) {
      setDataItem(dataItem => {
        const item = { ...dataItem };
        item.visitYn = "Y";
        return item;
      })
    } else {
      setDataItem(dataItem => {
        const item = { ...dataItem };
        item.visitYn = "N";
        return item;
      })
    }
  }

  // 위험 상태 -> 정상 상태로 변환
  const changeEvent = () => {
    getAlarmNo(conn, dataItem.userId).then(response => {
      setDataItem(dataItem => {
        const item = { ...dataItem };
        item.alarmNo = response;
        return item;
      })
    })
    setChangeEventDialogVisible(true);
  }

  // 상태 지속시간 포맷
  const formatDataStatTime = () => {
    let text = "-"
    let hour;
    let min;

    if(dataItem.meainStatCode !== '20003') {
      hour = parseInt(dataItem.latestDataStatTime/60)
      min = dataItem.latestDataStatTime%60
      text = hour + '시간 ' + min + '분'
    } else if (dataItem.meainStatCode == '20005') {
      text = <span>설치예정</span>
    }
    return text;
  }

  // 대상자 상세정보 화면 이동
  const userId = dataItem.userId;
  const userTerm = dataItem.userTerm;
  const birthday = dataItem.birthday;
  const userGender = dataItem.userGender;
  const dongTerm = dataItem.dongTerm;
  const address = dataItem.address;
  const userPhone = dataItem.userPhone;
  const protectorPhone = dataItem.protectorPhone;
  const sickType = dataItem.sickType;
  const imei = dataItem.imei;
  const note = dataItem.note;
  const absenceYn = dataItem.absenceYn;
  const dangerYn = dataItem.dangerYn;
  const meainStatCode = dataItem.meainStatCode;
  const fileIdUserPhoto = dataItem.fileIdUserPhoto;
  const fileIdPlacePhoto1 = dataItem.fileIdPlacePhoto1;
  const fileIdPlacePhoto2 = dataItem.fileIdPlacePhoto2;

  const goUserDetail = () => {
    history.push({
      pathname: "/user/info/detail",
      state: { userId, userTerm, birthday, userGender, dongTerm, address, userPhone, protectorPhone, sickType, note, absenceYn, dangerYn,
         meainStatCode, imei, fileIdUserPhoto, fileIdPlacePhoto1, fileIdPlacePhoto2 },
    });
  }

  // 대상자 모니터링 상세 정보 화면 이동
  const goUserMonitor = (e) => {
    let dataType = "";
    const cid = dataItem.cid;
    if(e.currentTarget.id === "move") {
      dataType = "movement";
    } else if(e.currentTarget.id === "temperature") {
      dataType = "temperature";
    } else if(e.currentTarget.id === "humidity") {
      dataType = "humidity";
    } else if(e.currentTarget.id === "co2") {
      dataType = "co2";
    } else if(e.currentTarget.id === "light") {
      dataType = "light";
    } else if(e.currentTarget.id === "velocityTotal") {
      dataType = "velocityTotal";
    } else {
      return;
    }
    history.push({
      pathname: "/user/info/monitor",
      state: { dataType, cid},
    });
  }

  useEffect(() => {
    setLoading(true);
    
    getUserInfo(conn, isUser() || isProtector() ? search.userId : location.state.userId)
    .then((response) => {
      const result = response[0];
      setDataItem(dataItem => {
        const item = { ...dataItem };
        // 대상자 정보
        item.userTerm = result.userTerm;
        item.meainStatCode = result.meainStatCode;
        item.meainStatTerm = result.meainStatTerm;
        item.dataStatSctCodeNo = result.dataStatSctCodeNo;
        item.dataStatTerm = result.dataStatTerm;
        item.latestDataStatTime = result.latestDataStatTime;
        item.movement = result.movement;
        item.velocityTotal = result.velocityTotal;
        item.temperature = result.temperature;
        item.humidity = result.humidity;
        item.co2 = result.co2;
        item.light = result.light;
        item.cid = result.cid;
        item.bizType = result.bizType;
        item.userId = result.userId;
        // 대상자 상세정보
        item.birthday = result.birthday;
        item.userGender = result.userGender;
        item.dongTerm = result.dongTerm;
        item.address = result.address;
        item.userPhone = result.userPhone;
        item.protectorPhone = result.protectorPhone;
        item.sickType = result.sickType;
        item.note = result.note;
        item.absenceYn = result.absenceYn;
        item.dangerYn = result.dangerYn;
        item.fileIdUserPhoto = result.fileIdUserPhoto;
        item.fileIdPlacePhoto1 = result.fileIdPlacePhoto1;
        item.fileIdPlacePhoto2 = result.fileIdPlacePhoto2;
        item.imei = result.imei;
        return item;
      });
      setLoading(false);
      setState(result);
    })
    .catch((error) => {
      console.log("getUserInfo error = ", error);
    })

    return () => {
      // 컴포넌트가 마운트 해제될 때 작업 취소
    }
  },[])
  return (
    <>
      <div className="pageContent_m">
        <div className="sub_02">
          <section className="sub_container_01">
            <ul onClick={goUserDetail}>
              <li className="txt_box_01">
                <span className="span_01">{dataItem.userTerm}님
                  <br/>
                  <span className="span_02" style={{backgroundColor: eventBackground()}}>{dataItem.meainStatTerm}{userEventImg()}</span>
                </span>
              </li>
              <li className="txt_box_02">
                {userStateImg()}
                {/* <img src="/images/mobile/con_01_b.png" alt="고활동표시" /> */}
              </li>
              <li className="txt_box_03">
                <span>{dataItem.dataStatTerm ? dataItem.dataStatTerm : dataItem.meainStatTerm}</span>
                <br />
                <strong>{formatDataStatTime()}</strong>
              </li>
              <li className="txt_box_04">
                <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
              </li>
            </ul>
            {dataItem.meainStatCode === "20004" && (userInfo.userTypeCode == 2002 || userInfo.userTypeCode == 2003 || userInfo.userTypeCode == 2005) ?
              <ul className="subUl">
                <li className="txt_box_05">
                  통화확인 <Checkbox id="callYn" defaultChecked={false} label={false} onChange={callCheckEvent} />
                </li>
                <li className="txt_box_06">
                  방문확인 <Checkbox id="visitYn" defaultChecked={false} label={false} onChange={visitCheckEvent} />
                </li>
                <li className="txt_box_07">
                  <button id="changeEventBtn" disabled={dataItem.callYn === "N" && dataItem.visitYn === "N"} onClick={changeEvent}>정상전환<img src="/images/mobile/change.png"></img></button>
                </li>
              </ul>
              :
              null
            }
            {changeEventDialogVisible && (
              <Dialog 
                className="changeEventDialog"
                width={"80vw"}
                height={"60vh"}
                title={"조치내용"} 
                onClose={closeChangeEventDialog} 
                closeIcon={false}
              >
                  {/* <p>조치내용</p> */}
                  <textarea maxLength={200} onChange={changeEventContent}></textarea>
                <DialogActionsBar>
                  <button className="button_01" onClick={saveChangeEventDialog}>
                    저장
                  </button>
                  <button className="button_02" onClick={closeChangeEventDialog}>
                    취소
                  </button>
                </DialogActionsBar>
              </Dialog>
            )}
            {completeDialogVisible && (
              <Dialog
                className="completeDialog"
                width={"90vw"}
                height={"40vw"}
                closeIcon={false}
              >
                <p>
                  저장되었습니다.
                  <br></br>
                  <button onClick={closeCompleteDialog}>확인</button>
                </p>
              </Dialog>
            )}
          </section>
          <section className="sub_container_02">
            {dataItem.bizType === "5003" ?
            <ul id="velocityTotal" className="sub_container_02_list" onClick={goUserMonitor}>
              <li className="txt_box_01">
                <img src="/images/mobile/icon_10.png" alt="움직임표시" />
              </li>
              <li className="txt_box_02">
                <span>활동량</span>
                <br />
                <strong>{dataItem.velocityTotal !== null ? dataItem.velocityTotal : "- "}</strong>
              </li>
              <li className="txt_box_03">
                <ul>
                  <li>낮음</li>
                  <li>표준</li>
                  <li>높음</li>
                  <ProgressBar className="progressbar" value={dataItem.velocityTotal} labelVisible={false} max={3000}/>
                </ul>
              </li>
              <li className="txt_box_04">
                <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
              </li>
            </ul>
            :
            <ul id="move" className="sub_container_02_list" onClick={goUserMonitor}>
              <li className="txt_box_01">
                <img src="/images/mobile/icon_10.png" alt="움직임표시" />
              </li>
              <li className="txt_box_02">
                <span>활동량</span>
                <br />
                <strong>{dataItem.movement !== null ? dataItem.movement : "- "}</strong>
              </li>
              <li className="txt_box_03">
                <ul>
                  <li>낮음</li>
                  <li>표준</li>
                  <li>높음</li>
                  <ProgressBar className="progressbar" value={dataItem.movement} labelVisible={false} max={500}/>
                </ul>
              </li>
              <li className="txt_box_04">
                <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
              </li>
            </ul>
            }
            <ul id="temperature" className="sub_container_02_list" onClick={goUserMonitor}>
              <li className="txt_box_01">
                <img src="/images/mobile/icon_11.png" alt="온도표시" />
              </li>
              <li className="txt_box_02">
                <span>온도</span>
                <br />
                <strong>{dataItem.temperature !== null ? dataItem.temperature : "- "}℃</strong>
              </li>
              <li className="txt_box_03">
                <ul>
                  <li>낮음</li>
                  <li>표준</li>
                  <li>높음</li>
                  <ProgressBar className="progressbar" value={dataItem.temperature} labelVisible={false} max={48}/>
                </ul>
              </li>
              <li className="txt_box_04">
                <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
              </li>
            </ul>
            <ul id="humidity" className="sub_container_02_list" onClick={goUserMonitor}>
              <li className="txt_box_01">
                <img src="/images/mobile/icon_12.png" alt="습도표시" />
              </li>
              <li className="txt_box_02">
                <span>습도</span>
                <br />
                <strong>{dataItem.humidity !== null ? dataItem.humidity : "- "} %</strong>
              </li>
              <li className="txt_box_03">
                <ul>
                  <li>낮음</li>
                  <li>표준</li>
                  <li>높음</li>
                  <ProgressBar className="progressbar" value={dataItem.humidity} labelVisible={false} max={80}/>
                </ul>
              </li>
              <li className="txt_box_04">
                <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
              </li>
            </ul>
            {/* 1차 장비, 2차 장비 필터 */}
            {
            dataItem.bizType ? 
              dataItem.bizType === "5001" ?
                null
                : 
                <>
                  <ul id="co2" className="sub_container_02_list" onClick={goUserMonitor}>
                    <li className="txt_box_01">
                      <img src="/images/mobile/icon_13.png" alt="CO2표시" />
                    </li>
                    <li className="txt_box_02">
                      <span>CO2</span>
                      <br />
                      <strong>{dataItem.co2 !== null ? dataItem.co2 : "- "} ppm</strong>
                    </li>
                    <li className="txt_box_03">
                      <ul>
                        <li>낮음</li>
                        <li>표준</li>
                        <li>높음</li>
                        <ProgressBar className="progressbar" value={dataItem.co2} labelVisible={false} max={1200} />
                      </ul>
                    </li>
                    <li className="txt_box_04">
                      <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
                    </li>
                  </ul>
                  <ul id="light" className="sub_container_02_list" onClick={goUserMonitor}>
                    <li className="txt_box_01">
                      <img src="/images/mobile/icon_14.png" alt="조도표시" />
                    </li>
                    <li className="txt_box_02">
                      <span>조도</span>
                      <br />
                      <strong>{dataItem.light !== null ? dataItem.light : "- "} Lx</strong>
                    </li>
                    <li className="txt_box_03">
                      <ul>
                        <li>낮음</li>
                        <li>표준</li>
                        <li>높음</li>
                        <ProgressBar className="progressbar" value={dataItem.light} labelVisible={false} max={800}/>
                      </ul>
                    </li>
                    <li className="txt_box_04">
                      <img src="/images/mobile/arw2_btn.png" alt="자세히보기" />
                    </li>
                  </ul>
                </>
                :
                null
            }
          </section>
        </div>
      </div>
      {loading && (
        <p
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default UserInfoMobile;
